var LiveChatVisibleUrls = ['/hesabim/siparislerim', '/hesabim/yarim-kalan-siparislerim'];
export default LiveChatVisibleUrls;
